import {select} from "d3-selection";
import {Selector, sizeToValue} from "../mixins/dictionaries";
import {getSlotContent, getSlotTitle, standardColoring} from "../utils/plasmid";
import {fixOffsetScrollPosition, rangeOverlapStart} from "./utils";
import {linearPreviewHeight} from '../mixins/constants'

const d3 = {select};

export default class LinearCartoon {
    constructor(settings, mediator) {
        this.mediator = mediator;
        this.initEditor();
    }

    initEditor() {
        this.initContainer();
        this.EventsOn();
    }

    initContainer() {
        this.$containerSize = document.querySelector(Selector.CARTOON);

        const $cartoonContainer = d3.select(Selector.CARTOON)
            .append("div")
            .attr("class", "slices overflow-hidden")
            .append("svg")
            .style("height", `${linearPreviewHeight}px`)
            .style("width", "100%")

        this.rulerContainer = $cartoonContainer.append("g")
            .attr("transform", `translate(0,${this.$containerSize.offsetHeight / 2})`);

        this.slotsContainer = $cartoonContainer.append("g");

        this.currentSlot = -1;
        this.zoom = .65;

        this.step = 10 * this.zoom;
        this.arrowOffset = 12 * this.zoom;
        this.slotHeight = 60 * this.zoom;
    }

    setData(data) {
        this.slots = [];
        let editorLength = 0;

        data.slots.forEach((s) => {
            this.slots.push(s);
            editorLength += s.length
        });

        this.sequenceLength = editorLength;

        this.render()
    }

    render() {
        this.drawRuler();
        this.drawSlots();
    }

    drawRuler() {
        this.rulerContainer.append("g")
            .attr("class", "lines")
            .append("path")
            .attr("class", this.slots.length === 0 ? 'stroke-primary-light' : 'ruler')
            .attr("d", `M0,0 L${this.$containerSize.offsetWidth},0`)
            .style("fill", "none")
            .style("stroke-width", 5 * this.zoom)
            .attr("opacity", 1);
    }

    drawSlots() {
        let start = 0;
        let end = this.step;

        this.slots.forEach(s => {
            this.drawSlot(s, end, start);
            end += this.slotWidth(s.size) + this.step;
            start += s.length
        });

        this.slotsContainer
            .attr("transform", `translate(${(this.$containerSize.offsetWidth - end) / 2},${(this.$containerSize.offsetHeight - this.slotHeight) / 2})`);
    }

    slotWidth(size) {
        const initWith = 25 * this.zoom;
        return sizeToValue[size] * initWith;
    }

    setAreaView(data) {
        this.areaViewSize = data.width;
    }

    drawSlot(slot, end, start) {
        let left = 0;
        let arrowLeft = 0;
        let right = this.slotWidth(slot.size);
        let arrowRight = this.slotWidth(slot.size);

        let areaShape = this.slotsContainer.append("g")
            .attr("class", "slice-labels")
            .attr("transform", `translate(${end}, 0)`);

        if (slot.shape === "arrow" && slot.direction) {
            if (slot.direction === 1) {
                right -= this.arrowOffset
            } else {
                left += this.arrowOffset
            }
        }

        let popperContent = getSlotContent(slot, true);
        let popperTitle = getSlotTitle(slot);

        areaShape.append("line")
            .attr("x1", 0).attr("y1", 0)
            .attr("x2", arrowRight).attr("y2", 0)
            .attr("stroke-width", "5");

        areaShape
            .append("path")
            .attr("data-toggle", "virtual-popper")
            .attr("data-virtual-popper-title", popperTitle)
            .attr("data-virtual-popper-content", popperContent)
            .attr("d", `M${left},0
                L${right},0
                L${arrowRight},${this.slotHeight / 2}
                L${right},${this.slotHeight}
                L${left},${this.slotHeight}
                L${arrowLeft},${this.slotHeight / 2}
                Z`)
            .attr("class", () => {
                return standardColoring(slot, undefined, false);
            })
            .on("click", (e) => {
                e.preventDefault();
                if (slot.length) {
                    this.EventsTrigger("selectRange", {
                        "start": start,
                        "end": rangeOverlapStart(start, start + 1, this.sequenceLength)
                    })
                } else {
                    this.EventsTrigger("selectRange", {
                        "start": (start + slot.length - .1),
                        "end": (start + slot.length - .1)
                    })
                }
                let offsetScroll = start;

                const maxEdgeOffsetScroll = this.sequenceLength - this.areaViewSize;
                offsetScroll -= Math.round(this.areaViewSize / 2);
                offsetScroll = fixOffsetScrollPosition(offsetScroll, maxEdgeOffsetScroll)

                this.EventsTrigger("setOffsetScroll", offsetScroll)
                this.EventsTrigger("slide", "end")
            })
    }

    EventsTrigger(action, data) {
        if (this.mediator) {
            this.mediator.trigger(action, data, this)
        }
    }

    EventsOn() {
        if (this.mediator) {
            this.mediator.on("setData", "setData", this);
            this.mediator.on("setAreaView", "setAreaView", this);
        }
    }
}